import { Checkbox, Tooltip } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../app/api";
import Loader from "../../components/Loader";
import Table from "../../components/Table";
import { keys } from "../../config/keys";
import { PoliciesContext } from "../../hooks/policiesContext";
import useAuth from "../../hooks/useAuth";
import useAgreement from "../../hooks/useAgreement";
import PDF from "./pdf";
import DownloadButton from "../../components/downloadButton"
import { convertToLocal } from "../../config/functions";
const FilesList = ({ template, limit, page, setPage, setLimit }) => {
  const { agreements } = useSelector((state) => state.Agreement);
  const { deleteAgreement, loading, getAgreements } = useAgreement();
  const { isAdmin, isCompany, isManager } = useAuth();
  const { selectedForShare, addForShare, removeFromShare } =
    useContext(PoliciesContext);
  const navigator = useNavigate();
  const onView = (item) => {
    // window.open(`${keys.BASE_LOCAL_URL}/${item.url}`, "_blank", "noreferrer");
  };

  const labels = [
    "#",
    "Title",
    isAdmin ? "Company" : null,
    "Created at",
    "File",
    (isAdmin || isCompany) && !template && "Actions",
  ].filter((item) => item);
  const data = useMemo(() => {
    return agreements?.map((item, index) => {
      return {
        data: item,
        fields: [
          ((isAdmin || isCompany || isManager) && !template) ? (
            <Checkbox
              checked={selectedForShare.includes(item)}
              onChange={async (e) => {
                if (e.target.checked) {
                  addForShare(item);
                } else {
                  removeFromShare(item);
                }
              }}
            />
          ) : (
            item._id?.substring(0, 5)
          ),
          item?.title,
          isAdmin ? <p>{item?.companyID?.name}</p> : null,
          convertToLocal(item?.createdAt),
          template ? (
            <button
              onClick={() => {
                if (template) {
                  navigator("/agreementInput", { state: item });
                } else {
                  onView(item);
                }
              }}
              className="btn btn-sm btn-success"
            >
              Select
            </button>
          ) : (
            <DownloadButton
              PDF={<PDF data={item} />}
              item={item}
              fileName={item?.title + `.pdf`}
            />
          ),

          (isAdmin || isCompany) && !template && (
            <div className="d-flex gap-3">
              <Tooltip title="Clone Agreement">
                <i
                  className="bi bi-file-earmark-plus"
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    navigator("/agreementInput", { state: { ...item, _id: null, agID: item._id } })
                  }}
                ></i>
              </Tooltip>
              <i
                className="bi bi-eye text-success"
                style={{ cursor: "pointer" }}
                onClick={() => navigator("/agreementInput", { state: item })}
              ></i>
              {loading?._id == item?._id ? (
                <div className="d-flex align-items-center justify-content-center ">
                  <Loader loading={loading} color={"red"} />
                </div>
              ) : (
                <i
                  className="bi bi-trash text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => deleteAgreement(item?._id)}
                ></i>
              )}
            </div>

          ),
        ].filter((it) => it),
      };
    });
  }, [agreements, selectedForShare, template, loading]);

  return (
    <>
      <Table
        labels={labels}
        data={data}
        limit={limit}
        page={page}
        setPage={setPage}
        setLimit={setLimit}
      />
    </>
  );
};

export default FilesList;
// Component to handle conditional PDF download link
const DownloadPDFButton = ({ item }) => {
  const [showLink, setShowLink] = useState(false);

  return (
    <>
      {!showLink ? (
        <button
          onClick={() => setShowLink(true)}
          className="btn btn-sm btn-primary"
        >
          Download PDF
        </button>
      ) : (
        <DownloadButton
          PDF={<PDF data={item} />}
          item={item}
          fileName={item?.title + `.pdf`}
        />
        // <PDFDownloadLink
        //   document={<PDF data={item} />}
        //   fileName={item?.title + `.pdf`}
        // >
        //   {({ loading }) =>
        //     loading ? (
        //       <button className="btn btn-sm btn-primary">Loading...</button>
        //     ) : (
        //       <button className="btn btn-sm btn-primary">Download PDF</button>
        //     )
        //   }
        // </PDFDownloadLink>
      )}
    </>
  );
};